import { FC } from 'react'
import { reportedAudioStatus } from './model/remote-status'
import { MediaRemoteControl } from './presentation/media-remote-control'
import { useConsoleMedia, useReloadProjectorMedia } from './presenter-console'
import { useMediaRemote } from './use-media-remote'

/**
 * The console's stand-in for the audio player while presenting
 * (`TrainerFocusedFeature`, surface `console`): the recording plays in the
 * presentation window, this card only sends the player's commands - and shows
 * whether that player has the recording (`reportedAudioStatus`), with a way to
 * have it load the file again. A film gets a video monitor instead
 * (`ConfiguredVideoMonitor`).
 */
export const ConfiguredMediaRemote: FC = () => {
	const remote = useMediaRemote('audio')
	const status = reportedAudioStatus(useConsoleMedia())
	const reload = useReloadProjectorMedia()
	return remote ? (
		<MediaRemoteControl {...remote} status={status} onRetry={reload} />
	) : null
}

export default ConfiguredMediaRemote
